import { useMemo } from 'react';

export function useNormalizedIds(ids: Array<string>) {
  return useMemo(() => Array.from(new Set(ids.filter(Boolean))).sort(), [ids]);
}
